// 获取cookie、
export const getCookie = (name) => {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  const arr = document.cookie.match(reg)
  if (arr && arr.length > 2) {
    return decodeURIComponent(arr[2])
  } else {
    return null
  }
}

// 设置cookie,增加到vue实例方便全局调用
export const setCookie = (cName, value, expiredays) => {
  let exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  let domain = ''
  try {
    if (window.location.host.indexOf('glodon.com') > -1){
      domain = 'domain=glodon.com;'
    }
  } catch (error){}
  // document.cookie = cName + '=' + encodeURIComponent(value) + ((expiredays == null) ? '' : 'expires=' + exdate.toGMTString()) + ';' + domain + 'path=/'
  document.cookie = cName + '=' + encodeURIComponent(value) + ((expiredays == null) ? '' : 'expires=' + exdate.toGMTString()) + ';' + domain + 'path=/;secure=true;sameSite=none;'
}

// 删除cookie
export const delCookie = (name, domain) => {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let value = getCookie(name)
  if (value !== null || value !== undefined) {
    // 清除当前域名下的,例如：zjy.glodon.com
    document.cookie = name + '=' + value + ';expires=' + exp.toUTCString()
    try {
      if (window.location.host.indexOf('glodon.com') > -1){
        // domain ? 清除 domain 下的cookie : 清除 .glodon.com 的cookie
        document.cookie = name + '=' + value + ';domain=' + (domain || 'glodon.com') + ';expires=' + exp.toUTCString()
      }
    } catch (error){
      console.log(error)
    }
  }
}

/*
  删除所有cookie
  params:
    expect: Object 不需要删除的cookie字段名称对象。 如: expect = {phone: true} 则将会删除phone之外的其他cookie
    domain: 删除 domain 这个域名下的cookie
 */
export const deleteAllCookie = (expect, domain) => {
  const obj = expect || {}
  const names = document.cookie.match(/[^ =;]+(?==)/g) || []
  for (let i = names.length; i >= 0; i--) {
    if (!obj[names[i]]) {
      delCookie(names[i], domain)
    }
  }
}

export const promisify = (fn, receiver) => {
  return () => {
    let args = []
    for (let _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }

    return new Promise((resolve, reject) => {
      fn.apply(receiver, [].concat(args, [(err, res) => {
        return err ? reject(err) : resolve(res)
      }]))
    })
  }
}


const stringifyPrimitive = function (v) {
  switch (typeof v) {
    case 'string':
      return v

    case 'boolean':
      return v ? 'true' : 'false'

    case 'number':
      return isFinite(v) ? v : ''

    default:
      return ''
  }
}

export const queryEncode = (obj, sep, eq, name) => {
  sep = sep || '&'
  eq = eq || '='
  if (obj === null) {
    obj = undefined
  }
  let reStr = ''
  if (typeof obj === 'object') {
    reStr = Object.keys(obj).map(function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq
      if (Array.isArray(obj[k])) {
        return obj[k].map(function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v))
        }).join(sep)
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]))
      }
    }).join(sep)
    return reStr
  }
  if (!name) return ''
  reStr = encodeURIComponent(stringifyPrimitive(name)) + eq +
      encodeURIComponent(stringifyPrimitive(obj))
  return reStr
}

export const previewShareGtj = (that) => {
  let fromPath = ''
  if (/\/preview\/gtj/.test(that.$route.path)) {
    let href = window.location.href
    let hrefPrefix = href.substring(0, href.indexOf(that.$route.path))
    if (hrefPrefix.indexOf('#') > -1) {
      hrefPrefix = hrefPrefix.substring(0, hrefPrefix.indexOf('#'))
    }
    let {fileName, fileId, shareToken, jsonToken} = that.$route.query
    setCookie('shareToken', shareToken)
    setCookie('jsonToken', jsonToken)
    const projectIOType = encodeURIComponent('个人')
    fileName = encodeURIComponent(encodeURIComponent(fileName))
    // hrefPrefix = 'https://zjytest.glodon.com/'
    fromPath = hrefPrefix + `model-browsing/#/browsing/filename/${fileName}/path/null/spaceType/1/projectIOType/${projectIOType}/fileId/${fileId}`
  }
  // http://zjytest.glodon.com//#/preview/gtj?shareToken=fgrOVy&fileId=869d380dcde5480ea0fc60b39a6f3887&fileType=10000&jsonToken=lJPVDO&fileName=GTJNEW-3130-727873939-%E8%A7%82%E4%BA%91%E5%B1%B12%23216%281%29.GTJ
  // http://zjytest.glodon.com//#/index?fromPath=http%3A%2F%2Fzjytest.glodon.com%2F%2Fmodel-browsing%2F%23%2Fbrowsing%2Ffilename%2FGTJNEW-3130-727873939-%2525E8%2525A7%252582%2525E4%2525BA%252591%2525E5%2525B1%2525B12%252523216%281%29.GTJ%2Fpath%2Fnull%2FspaceType%2F1%2FprojectIOType%2F%E4%B8%AA%E4%BA%BA%2FfileId%2F869d380dcde5480ea0fc60b39a6f3887
  // https://account.glodon.com//tokenLogin?token=uxVhc6UW5Q75AT4Gmb0nIkhaKFaUJNyj&target_url=http%3A%2F%2Fzjytest.glodon.com%2Fmodel-browsing%2F%23%2Fbrowsing%2Ffilename%2FGTJNEW-3130-727873939-%252525E8%252525A7%25252582%252525E4%252525BA%25252591%252525E5%252525B1%252525B12%25252523216%281%29.GTJ%2Fpath%2Fnull%2FspaceType%2F1%2FprojectIOType%2F%E4%B8%AA%E4%BA%BA%2FfileId%2F869d380dcde5480ea0fc60b39a6f3887
  // http://zjytest.glodon.com/model-browsing/#/browsing/filename/GTJNEW-3130-727873939-%25E8%25A7%2582%25E4%25BA%2591%25E5%25B1%25B12%2523216(1).GTJ/path/null/spaceType/1/projectIOType/个人/fileId/869d380dcde5480ea0fc60b39a6f3887
  return fromPath
}

// 网易易盾
export const captchaId = 'f48c8384d76e43669e25f1f9f95ecbfc'

// 短信登录加密字段
export const appId = 'zjy_web_12521397349756'

// 短信登录防刷标识
export const aes = (time, mobile) => {
  // node 包
  const crypto = require('crypto')
  // 后端约定的id

  const data = 'appId:' + appId + ',mobile:' + mobile + ',t:' + time
  // 后端约定的key 和 iv
  const key = '75784fc6959382a8'
  const iv = '75784fc6959382a8'
  let cipher = crypto.createCipheriv('aes-128-cbc', key, iv)
  let cipherChunks = []
  cipherChunks.push(cipher.update(data, 'utf8', 'base64'))
  cipherChunks.push(cipher.final('base64'))
  let str = cipherChunks.join('')
  let md5 = crypto.createHash('md5')
  md5.update(str)
  let scret = md5.digest('hex')
  return scret
}

